import axios from "axios";
import { useQuery } from "@tanstack/react-query";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const sameOrigin = (() => {
  try {
    return new URL(API).origin === window.location.origin;
  } catch {
    return false;
  }
})();

export const api = axios.create({ baseURL: API, withCredentials: sameOrigin });

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config;
    if (err.response?.status === 401 && cfg && !cfg._retry && !cfg.url.startsWith("/auth/")) {
      cfg._retry = true;
      try {
        await api.post("/auth/refresh");
        return api(cfg);
      } catch {
        return Promise.reject(err);
      }
    }
    return Promise.reject(err);
  },
);

export const useApi = (path, params) =>
  useQuery({
    queryKey: [path, params],
    queryFn: async () => (await api.get(path, { params })).data,
    retry: 1,
  });

export const CATEGORIES = ["fashion", "culture", "art", "beauty", "riot"];
// What readers see; the address stays /category/<slug>.
const LABELS = { art: "Art & Photography" };
export const catLabel = (c) => LABELS[c] ?? c ?? "";
export const catLines = (c) => (LABELS[c] ? ["Art &", "Photography"] : [c]);

export const fmtDate = (iso) => {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "" : d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
};

export const splitLines = (text = "", perLine = 3) => {
  const words = text.split(" ");
  const lines = [];
  for (let i = 0; i < words.length; i += perLine) lines.push(words.slice(i, i + perLine).join(" "));
  return lines;
};
